import { CellProps } from 'react-table';
import AutocompleteV2 from '../../../../component/AutocompleteObjectV2';
import EditableCell from '../../../modals/modal-chi-dinh-dich-vu/cells/EditableCell';

const ObjectTypeCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData, objectTypes } = tableOptions;
	const rowData = row.original;

	return (
		<EditableCell
			editComponent={({ setEnableEditing }: any) => {
				return (
					<AutocompleteV2
						autoFocus
						options={objectTypes || []}
						value={{
							code: rowData?.objectTypeCode,
							name: rowData?.objectTypeName,
						}}
						name="objectType"
						getOptionValue={(option: any) => option.code}
						onChange={(selectedOption) => {
							updateRowData(row.index, "objectType", selectedOption);
							setEnableEditing(false);
						}}
						onBlur={() => {
							setEnableEditing(false);
						}}
						isClearable={false}
					/>
				);
			}}
			textValue={rowData?.objectTypeName}
		/>
	);
};

export default ObjectTypeCell;
